import React, { useState } from 'react';

const SignUp = () => {
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    verifyPassword: '',
    usertype: '',
    zipcode: '',
  });
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.verifyPassword) {
      setMessage('Passwords do not match.');
      return;
    }
    // Use email as username for signup
    const payload = {
      ...form,
      username: form.email,
      usertype: 1
    };
    try {
  const res = await fetch(`${process.env.REACT_APP_SERVICE_DOMAIN}/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage('Sign up successful! Verification email sent.');
        setTimeout(() => {
          window.location.href = '/signin'; // Redirect to login page
        }, 1500); // Wait 1.5 seconds before redirecting
      
      } else {
        setMessage(data.message || 'Sign up failed.');
      }
    } catch (err) {
      setMessage('Sign up failed.');
    }
  };

  return (
    <div style={styles.container}>
      <form style={styles.form} onSubmit={handleSubmit}>
        <h2 style={styles.title}>Sign Up</h2>
        <input
          style={styles.input}
          type="text"
          name="firstName"
          placeholder="First Name"
          value={form.firstName}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="text"
          name="lastName"
          placeholder="Last Name"
          value={form.lastName}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="text"
          name="zipcode"
          placeholder="Zip Code"
          value={form.zipcode}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="password"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="password"
          name="verifyPassword"
          placeholder="Verify Password"
          value={form.verifyPassword}
          onChange={handleChange}
          required
        />
        <button style={styles.button} type="submit">Sign Up</button>
        {message && <div style={{ marginTop: '16px', color: '#4078c0', textAlign: 'center' }}>{message}</div>}
        <div style={{ marginTop: '24px', textAlign: 'center', fontSize: '15px' }}>
          Already have an account?{' '}
          <a href="/signin" style={{ color: '#4078c0', textDecoration: 'underline' }}>
            Sign In
          </a>
        </div>
      </form>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // background: '#f5f6fa', // Remove gray background
  },
  form: {
    background: '#fff',
    padding: '32px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    display: 'flex',
    flexDirection: 'column',
    width: '320px',
  },
  title: {
    marginBottom: '24px',
    textAlign: 'center',
    color: '#2f3640',
  },
  input: {
    marginBottom: '16px',
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #dcdde1',
    fontSize: '16px',
  },
  button: {
    padding: '12px',
    borderRadius: '4px',
    border: 'none',
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '16px',
    cursor: 'pointer',
  },
};

export default SignUp;